'use strict';

/**
 * @classname BreadCrumb.js
 * @classdesc タグ幅拡張
 */
export default class BreadCrumb {
	/**
	 * @constructor
	 * @param {jQuery} $e - .form-group__content--tag .input-checkbox
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const height = $e.outerHeight();
		if(height > 25){
			$e.css('width', '100%');
		}
	};
};
